import { createSelector } from '@ngrx/store';

import { BlockState } from '../state/block.state';
import { selectBlockState } from './block.selectors';

export const selectAlertsCounterComponent = createSelector(
  selectBlockState,
  (state: BlockState) => state.blockList.AlertsCounterComponent
);

export const selectSystemAlertsCounterBySystemId = (
  systemId: string,
  instanceId: string
) => createSelector(
  selectAlertsCounterComponent,
  (alertsCounterComponent) => {
    const instanceBlock = alertsCounterComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }
    return instanceBlock[systemId]?.alerts;
  }
);

export const selectSystemAlertsCounterBySystemIdAcrossInstances = (
  systemId: string,
) => createSelector(
  selectAlertsCounterComponent,
  (alertsCounterComponent) => {
    // Reuse only hydrated counter data. Different block instances can coexist
    // briefly while one is still pending, so we skip anything not yet `ready`.
    return Object.values(alertsCounterComponent)
      .find((instanceBlock) => {
        const systemBlock = instanceBlock?.[systemId];
        return systemBlock?.state === 'ready' && Boolean(systemBlock.alerts);
      })
      ?.[systemId]
      ?.alerts ?? null;
  }
);

export const selectSystemAlertsCounterStatusBySystemId = (
  systemId: string,
  instanceId: string
) => createSelector(
  selectAlertsCounterComponent,
  (alertsCounterComponent) => {
    const instanceBlock = alertsCounterComponent[instanceId];
    if (!instanceBlock) {
      return null;
    }
    return instanceBlock[systemId]?.state;
  }
);
